<template id="chat">
    <v-ons-page>

        <v-ons-toolbar class="toolbarBack">
            <div class="left">
                <v-ons-toolbar-button @click="$router.push('/quiz')" class="back-icon"></v-ons-toolbar-button>
            </div>
            <div class="center toolbar-alignMent">
                <div>
                    <img class="verticallyMiddle" alt="quiz-image" src="../assets/hamropatro.png"
                         style="width: 22px;height: 22px"/>
                </div>
                <div class="predictWinWrapper">&nbsp;{{text.messages}}</div>
            </div>
            <div class="right">
                <v-ons-toolbar-button class="refresh" @click="getItems()"></v-ons-toolbar-button>
            </div>
        </v-ons-toolbar>
        <v-ons-pull-hook
                :action="pullItems"
                @changestate="state = $event.state"
        >
            <span v-show="state === 'initial'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="20"></v-ons-progress-circular>
            </span>
            <span v-show="state === 'preaction'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="40"></v-ons-progress-circular>
            </span>
            <span v-show="state === 'action'">
                <v-ons-progress-circular class="refreshButton circularPad"
                                         value="100"></v-ons-progress-circular>
            </span>
        </v-ons-pull-hook>
        <v-ons-toast :visible.sync="showSnack">
            {{snackBarMsg}}
            <button @click="showSnack = false"><i class="zmdi zmdi-close"></i>
            </button>
        </v-ons-toast>
        <p class="text-center" v-if="loading">
            <v-ons-progress-circular class="refreshButton" indeterminate></v-ons-progress-circular>
        </p>
        <div>
            <div style="margin-bottom: 0">
                <div class="text-center font14px" v-if="chatData===false">
                    <p class="colorWhite">{{text.msgText}}</p>
                </div>
                <div class="chat-room--list pa-3" style="overflow-y:auto; height: 87vh;padding: 15px 15px 0" id="scroll-chat" >
                    <template v-for="(value, key) in chatMessages">
                        <div v-bind:class="[ value.sender.userID === $route.params.uuid ? 'reverse' : '']" class="messaging-item layout row my-4" :key="key">
                            <div class="v-avatar mx-1" style="width: 30px; height: 30px">
                                <img :src="value.sender.img" alt="" v-if="value.sender.img" class="" style="">
                                <span v-else>{{firstLetter(value.sender.name)}}</span>
                            </div>
                            <div class="" style="max-width: 70%;margin: 0 5px 5px; ">
                                <p :value="true" v-bind:class="[ value.sender.userID === $route.params.uuid ? 'userStyle' : 'nonUser']" class="colorWhite" style="font-size:15px;line-height:1.3;height:auto; padding: 10px 15px !important; margin: 0 0 5px;" >
                                    {{value.msg}}
                                </p>
                                <div v-bind:class="[ value.sender.userID === $route.params.uuid ? 'clearBoth chatDate colorWhite floatRight' : 'clearBoth chatDate colorWhite floatLeft']">{{new Date(Number(key)).toLocaleString()}}</div>
                            </div>
                        </div>
                    </template>
                    <div class="text-center">
                        <v-ons-progress-circular v-if="loading" style="border-radius: 50%; height: 20px; width: 20px;" indeterminate></v-ons-progress-circular>
                        <span v-if="loading" class="colorWhite">...</span>
                        <span v-else class="colorBlue">&nbsp;</span>
                    </div>
                    <div class="font10px text-center my-4" v-if="chatData===true && channelStatus===false" style="position: relative; bottom: 20px">
                        <span class="colorWhite" style="padding: 7px 10px; border: 1px solid #e5e5e5; border-radius: 15px;"> {{text.msgClosed}}</span>
                    </div>
                </div>
            </div>
            <div style="background: #ffffff" class="textareaWrapper fullWidth">
                <div>
                    <textarea
                            :disabled="!channelStatus"
                            class="textarea sendMessageBox"
                            v-model="messageText"
                            :append-icon-cb="sendMessage"
                            :placecholder="messageText ? 'Type some message here' : 'Your conversation Box'">
                    </textarea>
                    <img class="verticallyMiddle" alt="quiz-image" src="../assets/icons/send.svg" @click="channelStatus?sendMessage():''"
                         style="width: 22px;height: 22px; margin-top: 10px"/>
                </div>
            </div>
        </div>
    </v-ons-page>
</template>

<script>
    import {getChatMessage,sendMessageText,getChannelStatus} from '../api/requests/chat';
    import usedText from "../util/languageText";

    export default {
        name: "Chat",
        data: () => ({
            // forSnackbar
            showSnack: null,
            snackBarMsg: null,
            loading: true,
            state: 'initial',
            quizId: null,
            chatMessages: null,
            chatData:null,
            messageText: null,
            channelStatus:null,
            text:usedText
        }),
        created() {
            this.getItems();
        },

        mounted () {
            this.scrollToEnd();
        },
        updated () {
            this.scrollToEnd();
        },
        methods: {
            getItems() {
                //remove snackBar
                let self = this;

                this.getChannel();
                this.chatConversation();
                setTimeout(function () {
                    self.showSnack = false;
                }, 2000);
            },
            chatConversation () {
                let self = this;
                self.loading = true;
                self.showSnack = false;
                getChatMessage(self.$route.params.uuid).then(function (response) {
                    if (response.success) {
                        self.loading = false;
                        self.chatData=true;
                        self.chatMessages = response.data;
                    } else {
                        // show SnackBar
                        self.chatData=false;
                        // self.snackBarMsg = response.msg;
                        // self.showSnack = true;
                    }
                }).catch(function (error) {
                    self.loading = false;
                    self.chatData=false;
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            getChannel () {
                let self = this;
                self.showSnack = false;
                getChannelStatus(self.$route.params.uuid).then(function (response) {
                    if (response.success) {
                        self.channelStatus = response.data;
                    }
                    // else {
                    //     // show SnackBar
                    //     self.snackBarMsg = response.msg;
                    //     self.showSnack = true;
                    // }
                }).catch(function (error) {
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            sendMessage: function () {
                if(!this.messageText) {
                    this.showSnack = true;
                    this.snackBarMsg = 'Please Type some Messages.';
                    let self= this;
                    setTimeout(function () {
                        self.showSnack = false;
                    }, 2000);
                    return;
                }
                let self = this;
                self.channelStatus = null;
                self.loading = true;
                let jsonData = {
                    'userID': this.$route.params.uuid,
                    'msg': this.messageText
                };
                sendMessageText(jsonData).then(function (response) {
                    self.channelStatus = true;
                    self.loading = false;
                    if (response.success) {
                        self.messageText = '';
                        self.getItems();
                    } else {
                        // self.snackBarMsg = response.msg;
                        // self.showSnack = true;
                    }
                }).catch(function (error) {
                    self.channelStatus = true;
                    self.loading = false;
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            scrollToEnd () {
                let container = document.getElementById('scroll-chat');
                let scrollHeight = container.scrollHeight;
                container.scrollTop = scrollHeight;
            },
            pullItems(done) {
                setTimeout(() => {
                    this.loading = true;
                    this.getItems();
                    done();
                }, 500);
            },
        }
    }
</script>